import type { FC } from 'react';

import type { Props } from '@/components/TreatmentGroupDetailSections/components/SessionRow/types';
import { DAY_LABELS } from '@/constants/dayOfWeek';
import { Typography } from '@/ui';
import { formatTimeOfDay } from '@/utils/dates';

const SessionRow: FC<Props> = ({ session }) => (
  <>
    <Typography variant="body">{DAY_LABELS[session.display_day_of_week]}</Typography>
    <Typography variant="body">{formatTimeOfDay(session.display_start_time)}</Typography>
    <Typography variant="body">{session.staff_name}</Typography>
  </>
);

export default SessionRow;
